export default function TitleComponent(title) {
  return (
    <div style={{ backgroundColor: "white" }}>
      <h2 style={{ color: "black", paddingLeft: 8 }}>{title}</h2>
    </div>
  )
}